import * as yup from "yup";

import { Button, Grid } from "@mui/material";
import { useEffect, useState } from "react";

import AutoComplete from "../../../../components/hookForms/autoComplete";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IGenericResult from "../../../../interfaces/IGenericResult";
import IconButton from "@mui/material/IconButton";
import InputNumber from "../../../../components/hookForms/inputNumber";
import messages from "../../../../utils/messages";
import serviceInstalacao from "../../../../services/serviceInstalacao";
import serviceSaldoInstalacao from "../../../../services/serviceSaldoInstalacao";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

export interface IDialogProps {
    open: boolean;
    onSuccess: () => void;
    onClose?: any;
}

export default function DialogNew({ open, onClose, onSuccess }: IDialogProps) {
    const [instalacoesDataOptions, setInstalacoesDataOptions] = useState<IGenericResult[]>([]);
    const [isDisable, setDisable] = useState(false);

    const validationSchema = yup.object().shape({
        instalacaoID: yup.string().required(messages.requiredField).typeError(messages.requiredField),
        quantidadeKW: yup.string().required(messages.requiredField),
        tipoSaldo: yup.string().required(messages.requiredField).typeError(messages.requiredField),
    });

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            instalacaoID: "",
            quantidadeKW: "",
            tipoSaldo: "",
        },
    });

    const tipoSaldoOptions = [
        { label: "Reenergisa", value: "Reenergisa" },
        { label: "Outras Empresas", value: "Outras Empresas" },
        { label: "Concessionária", value: "Concessionária" },
    ];

    useEffect(() => {
        setInstalacoesData();
    }, []);

    const setInstalacoesData = async () => {
        serviceInstalacao
            .getInstalacoes()
            .then((result) => {
                setInstalacoesDataOptions(result?.data);
            })
            .catch(() => {
                setInstalacoesDataOptions([]);
            });
    };

    const onSubmit = (values: any) => {
        setDisable(true);

        const newItem = {
            ...values,
            quantidadeKW: values.quantidadeKW
                ? Number(values.quantidadeKW.replaceAll(".", "").replaceAll(",", "."))
                : 0,
        };

        serviceSaldoInstalacao
            .create(newItem)
            .then((result) => {
                if (result) {
                    toast.success(messages.createSucess);
                    onClose(true);
                    reset();
                    onSuccess();
                }
            })
            .catch((err) => {
                toast.error(messages.createError, err);
            })
            .finally(() => {
                setDisable(false);
            });
    };

    return (
        <Dialog
            maxWidth="md"
            fullWidth
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    onClose();
                }
            }}
            open={open}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle>
                    Novo Saldo
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            reset();
                            onClose(true);
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers>
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={12}>
                            <AutoComplete
                                name="instalacaoID"
                                label="Número da Instalação"
                                options={instalacoesDataOptions}
                                control={control}
                                error={errors}
                                concatWithID={true}
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <AutoComplete
                                name="tipoSaldo"
                                label="Tipo de Saldo"
                                options={tipoSaldoOptions}
                                control={control}
                                error={errors}
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <InputNumber
                                name="quantidadeKW"
                                label="Quantidade Kilowatt"
                                control={control}
                                error={errors}
                                decimalScale={2}
                                maxLength={12}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                    <Button
                        onClick={() => {
                            reset();
                            onClose(true);
                        }}
                        color="warning"
                        variant="contained"
                        style={{ width: "159px", height: "44px" }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        type="submit"
                        color="primary"
                        variant="contained"
                        disabled={isDisable}
                        style={{ width: "159px", height: "44px" }}
                    >
                        Salvar
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}
